const addProductToCart = require('./product/addToCart');
const ajax = require('../ajax');
const page = require('../page');
const productTile = require('../product-tile');
const util = require('../util');
const quickview = require('../quickview');

/**
 * @private
 * @function
 * @description Binds the click events to the remove-link and quick-view button
 */
function initializeEvents() {
    $('#compare-table').on('click', '.remove-link', (e) => {
        e.preventDefault();
        ajax.getJson({
            url: e.currentTarget.href,
            callback() {
                if ($('.product-tile').length <= 1) {
                    if ($('#compare-category-list').length > 0) {
                        const nextCat = $('#compare-category-list option:not(:selected)').eq(0).val();
                        page.redirect(util.appendParamToURL(Urls.compareShow, 'category', nextCat));
                    } else {
                        const backUrl = $('#primary').find('a.back').attr('href');
                        page.redirect(backUrl);
                    }
                } else {
                    page.refresh();
                }
            },
        });
    }).on('click', '.open-quick-view', (e) => {
        e.preventDefault();
        const url = $(e.currentTarget).closest('.product').find('.thumb-link').attr('href');
        quickview.show({
            url,
            source: 'quickview',
        });
    });

    $('#compare-category-list').on('change', (e) => {
        $(e.currentTarget).closest('form').submit();
    });
    $('#compare-table .product-tile').each((index, element) => {
        $(element).find('.swatch.preselected').trigger('click');
    });
}

exports.init = function init() {
    productTile.init();
    initializeEvents();
    addProductToCart();
};
